export default __webpack_public_path__ + "static/media/black_princess.e90e7fe4.png";